/**
 * Main Collection Banner Section
 * Handles sidebar sync and description toggle functionality.
 */
(function() {
  /**
   * Syncs all banner layouts with the product grid sidebar state.
   * Adds 'has-sidebar' class when filters sidebar is visible.
   */
  function syncBannerLayout() {
    var bannerLayouts = document.querySelectorAll('.collection-banner-layout');
    var facetsWrap = document.querySelector('.facets-wrap');

    if (!bannerLayouts.length) return;

    var hasSidebar = facetsWrap && facetsWrap.classList.contains('page-layout-with-sidebar');

    bannerLayouts.forEach(function(layout) {
      if (hasSidebar) {
        layout.classList.add('has-sidebar');
      } else {
        layout.classList.remove('has-sidebar');
      }
    });
  }

  /**
   * Observes the facets-wrap element for class changes.
   */
  function observeSidebarChanges() {
    var facetsWrap = document.querySelector('.facets-wrap');
    if (!facetsWrap) return;

    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.attributeName === 'class') {
          syncBannerLayout();
        }
      });
    });

    observer.observe(facetsWrap, { attributes: true });
  }

  /**
   * Initializes the description toggle functionality with animation.
   */
  function initDescriptionToggle() {
    var wrapper = document.querySelector('.collection-description-wrapper');
    if (!wrapper) return;

    var shortDesc = wrapper.querySelector('.collection-description-short');
    var fullDesc = wrapper.querySelector('.collection-description-full');
    var showButton = wrapper.querySelector('.collection-description-toggle[data-action="show"]');
    var hideButton = wrapper.querySelector('.collection-description-toggle[data-action="hide"]');

    if (!shortDesc || !fullDesc) return;

    /**
     * Animates the transition between short and full descriptions.
     * @param {HTMLElement} fromEl - Element to hide
     * @param {HTMLElement} toEl - Element to show
     */
    function animateTransition(fromEl, toEl) {
      var startHeight = wrapper.offsetHeight;
      wrapper.style.height = startHeight + 'px';
      wrapper.style.overflow = 'hidden';

      fromEl.hidden = true;
      toEl.hidden = false;

      var endHeight = toEl.offsetHeight;

      wrapper.offsetHeight;

      wrapper.style.transition = 'height 0.3s ease-in-out';
      wrapper.style.height = endHeight + 'px';

      wrapper.addEventListener('transitionend', function handler() {
        wrapper.style.height = '';
        wrapper.style.overflow = '';
        wrapper.style.transition = '';
        wrapper.removeEventListener('transitionend', handler);
      });
    }

    if (showButton) {
      showButton.addEventListener('click', function() {
        animateTransition(shortDesc, fullDesc);
      });
    }

    if (hideButton) {
      hideButton.addEventListener('click', function() {
        animateTransition(fullDesc, shortDesc);

        wrapper.addEventListener('transitionend', function scrollHandler() {
          wrapper.removeEventListener('transitionend', scrollHandler);
          var section = wrapper.closest('.section-main-collection-banner');
          if (section) {
            section.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      syncBannerLayout();
      observeSidebarChanges();
      initDescriptionToggle();
    });
  } else {
    syncBannerLayout();
    observeSidebarChanges();
    initDescriptionToggle();
  }
})();
